/**
 * Safely pushes data to the Google Tag Manager dataLayer.
 * Initializes dataLayer if it doesn't exist.
 * 
 * @param data - The data object to push to dataLayer
 * @returns void
 */
export const safeDataLayerPush = (data: any): void => {
  if (typeof window !== 'undefined') {
    if (window.dataLayer === undefined) {
      window.dataLayer = [];
    }
    window.dataLayer.push(data);
  }
};

